import React from "react";
import PropTypes from "prop-types";

// components
import Creator from "./Creator";

// styles
import { TitleBlockContainer, ImageTitle } from "./styles";

const CreatorInfo = ({ title, creator }) => (
    <TitleBlockContainer data-testid="title-block-container">
        <ImageTitle>{title}</ImageTitle>
        <Creator creator={creator} />
    </TitleBlockContainer>
);

CreatorInfo.propTypes = {
    title: PropTypes.string.isRequired,
    creator: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired
};

export default CreatorInfo;
